var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.4675V4.2825C1.5 3.285 2.0775 3.045 2.7825 3.75L4.725 5.6925C5.0175 5.985 5.4975 5.985 5.7825 5.6925L8.4675 3C8.76 2.7075 9.24 2.7075 9.525 3L12.2175 5.6925C12.51 5.985 12.99 5.985 13.275 5.6925L15.2175 3.75C15.9225 3.045 16.5 3.285 16.5 4.2825V11.475C16.5 13.725 15 15.225 12.75 15.225H5.25C3.18 15.2175 1.5 13.5375 1.5 11.4675Z",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.c174f1b86910c8b768ad92de9855e599.svg";
export { ForwardRef as ReactComponent };